import { useFinancialDocument } from "@api/financialDocument.api";
import { accrualImporterDetailIncludes } from "@components/documents/financialDocumentDetailIncludes";
import { FinancialDocumentExtended } from "@common/types/financialDocument";
import { Loader } from "@design-system/Loader/Loader";
import importerStyles from "@components/importer/ImporterPage.module.scss";
import { AccrualDocumentReviewPanel } from "./AccrualDocumentReviewPanel";
import { AccrualDocumentImporterMode } from "./accrualDocumentImporter.lib";
import {
    getAccrualLineItemExtraction,
    accrualDocumentBeingProcessed,
} from "./accrualImporter.helpers";
import styles from "./AccrualDocumentImporter.module.scss";

interface Props {
    financialDocumentId: number;
    mode: AccrualDocumentImporterMode;
}

function isAccrualDocumentReviewable({
    financialDocument,
    mode,
}: {
    financialDocument: FinancialDocumentExtended;
    mode: AccrualDocumentImporterMode;
}) {
    return (
        !accrualDocumentBeingProcessed(financialDocument) &&
        getAccrualLineItemExtraction(financialDocument, mode) !== null
    );
}

export const AccrualDocumentReviewDrawerContent: React.FC<Props> = ({
    financialDocumentId,
    mode,
}) => {
    const {
        data: financialDocument,
        isPending,
        isError,
    } = useFinancialDocument(
        financialDocumentId,
        accrualImporterDetailIncludes,
    );

    if (isPending) {
        return (
            <div className={importerStyles.drawerContent}>
                <Loader />
            </div>
        );
    }

    if (isError || !financialDocument) {
        return (
            <div className={importerStyles.drawerContent}>
                <p className={styles.unavailableMessage}>
                    Could not load this document. Close and try again.
                </p>
            </div>
        );
    }

    if (!isAccrualDocumentReviewable({ financialDocument, mode })) {
        return (
            <div className={importerStyles.drawerContent}>
                <p className={styles.unavailableMessage}>
                    This document cannot be reviewed yet.
                </p>
            </div>
        );
    }

    return (
        <div className={importerStyles.drawerContent}>
            <AccrualDocumentReviewPanel
                financialDocument={financialDocument}
                mode={mode}
            />
        </div>
    );
};
